import { __awaiter } from "tslib";
import { MISSING_CUSTOMER } from '@open-tender/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { checkAuth, selectToken } from './customer';
import { showNotification } from './notifications';
const initialState = {
    error: null,
    loading: 'idle'
};
export var ClaimRewardCodeActionType;
(function (ClaimRewardCodeActionType) {
    ClaimRewardCodeActionType["ClaimRewardCode"] = "rewardCode/claimRewardCode";
})(ClaimRewardCodeActionType || (ClaimRewardCodeActionType = {}));
export const claimRewardCode = createAsyncThunk(ClaimRewardCodeActionType.ClaimRewardCode, ({ rewardCode, callback }, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        if (!token)
            throw new Error(MISSING_CUSTOMER);
        const discount = yield api.postClaimRewardCode(token, rewardCode);
        dispatch(showNotification('Reward Code Claimed!'));
        if (callback)
            callback();
        return discount;
    }
    catch (err) {
        const error = err;
        return checkAuth(error, dispatch, () => rejectWithValue(error));
    }
}));
const rewardCodeSlice = createSlice({
    name: 'rewardCode',
    initialState: initialState,
    reducers: {
        resetRewardCode: () => initialState,
        claimReward: state => {
            state.error = null;
            state.loading = 'idle';
        }
    },
    extraReducers: builder => {
        builder.addCase(claimRewardCode.pending, state => {
            state.error = null;
            state.loading = 'pending';
        });
        builder.addCase(claimRewardCode.fulfilled, state => {
            state.error = null;
            state.loading = 'idle';
        });
        builder.addCase(claimRewardCode.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { claimReward, resetRewardCode } = rewardCodeSlice.actions;
export const selectRewardCode = (state) => state.rewardCode;
export const rewardCodeReducer = rewardCodeSlice.reducer;
